import { Icon, Tabbar, TabbarLink } from "konsta/react"
import { useEffect, useRef, useState } from "react";
import { BsGpuCard, BsPersonBadge } from "react-icons/bs";
import { MdHomeMax, MdOutlineSettings, MdOutlineStorefront } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const TabBar = ({selectedTab} : {selectedTab: 'home' | 'miners' | 'store' | 'profile'}) => {
    const navigate = useNavigate()

    useEffect(() => {
      const elements = document.querySelectorAll('.absolute.w-full.h-full.left-0.top-0.bg-md-light-surface-2.dark\\:bg-md-dark-surface-2')
      if (elements && elements.length > 0) {
        // We need to select all because tabbar and toolbar components have the same class
        elements.forEach(element => {
          element.classList.remove('dark:bg-md-dark-surface-2');
          element.classList.remove('bg-md-light-surface-2');
        })
      }
    }, []);
    
    return <Tabbar icons className="left-0 bottom-0 fixed translucent ">
        <TabbarLink
          active={selectedTab === 'home'}
          onClick={() => navigate('/')}
          icon={
            <Icon
                material={<MdHomeMax className="w-6 h-6" />}
              />
          }
        />
        <TabbarLink
          active={selectedTab === 'miners'}
          onClick={() => navigate('/my-miners')}
          icon={
            <Icon
                material={<BsGpuCard className="w-6 h-6" />}
              />
          }
        />
        <TabbarLink
          active={selectedTab === 'store'}
          onClick={() => navigate('/store')}
          icon={
            <Icon
                material={<MdOutlineStorefront className="w-6 h-6" />}
              />
          }
        />
        <TabbarLink
          active={selectedTab === 'profile'}
          onClick={() => navigate('/profile')}
          icon={
            <Icon
                material={<BsPersonBadge className="w-6 h-6" />}
              />
          }
        />
    </Tabbar>
}

export default TabBar